// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__w8Tig","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1z75K","obliqueLine":"membershipbadge_obliqueLine__1yTGD"};